<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <inbox-header :title="title" :path="path" :text="text" :text1="text1" :showAddHoliday="showActionButton" />
      <!-- /Page Header -->

      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-striped custom-table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Holiday Date</th>
                  <th>Day</th>
                  <th class="text-end" v-if="showActionButton">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="holiday-upcoming" v-for="item in holidays" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.title }}</td>
                  <!-- <td> {{this.formattedDate(item.day, item.month)}}</td> -->
                  <td> {{ this.formatDDMMYYYY(`${(new Date).getFullYear()}-${item.month}-${item.day}`) }}</td>
                  <td>{{ this.getDayName(`${(new Date).getFullYear()}-${item.month}-${item.day}`) }}</td>
                  <td class="text-end" v-if="showActionButton">
                    <div class="dropdown dropdown-action">
                      <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit_holiday" @click="edit(item)"><i class="fa-solid fa-pencil m-r-5"></i>
                          Edit</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_holiday" @click="deleteClicked(item.id)"><i
                            class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <holiday-modal ref="editHoliday" @holidayModel="holidaysMaster"></holiday-modal>
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
// import Holidays from "@/assets/json/holidays.json";
import inboxHeader from "@/components/breadcrumb/inbox-header.vue";
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatDDMMYYYY } from "@/utils/util-funcitons";
export default {
  components: { inboxHeader },
  data() {
    return {
      holidays: null,
      title: "Holidays",
      path: "Dashboard",
      text: "Holidays",
      text1: "Add Holiday",
      accessToken: [],
      showActionButton: true
    };
  },
  mounted() {
    // this.holidays();
    this.setAction()
    this.holidaysMaster();
  },
  methods: {
    formatDDMMYYYY,
    holidaysMaster() {
      let headers = {
        "Access-Control-Allow-Headers": "*",
        "content-type": "application/json",
        "Accept": "/",
        "Authorization": "Bearer " + localStorage.getItem("accessToken"),
        "ngrok-skip-browser-warning": true
      };
      axios.get(VUE_APP_API_BASE_URL + '/holidays', { headers: headers }).then((response) => {
        if (response.data.status) {
          this.holidays = response.data.data
        }
      })
    },
    getDayName(date) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var d = new Date(date); //date "1995-02-14"
      return days[d.getDay()];
    },
    setAction() {
      this.accessToken = JSON.parse(localStorage.getItem("userInfo"));
      this.showActionButton = this.accessToken?.account_type === 'MEMBER' ? false : true;
    },
    edit(item) {
      this.$refs.editHoliday.edit(item);
    },
    deleteClicked(id) {
      this.$refs.editHoliday.delete(id);
    }
  },
};
</script>
<style scoped>
.table-responsive {
  height: 100vh;
  overflow: visible !important;
}
</style>
